import styled from 'styled-components';
const percentageSize = 1.3;
export const EditWrapper = styled.div`
  padding-left: 5px;
  padding-top: 10px;
  margin-bottom: 10px;
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 14 * percentageSize : 14)}px;
`;
export const OptionsWrapper = styled.div`
  display: flex;
  cursor: pointer;
  align-items: center;
  gap: 10px;
`;
export const OptionsContainer = styled.div`
  display: flex;
  padding-left: 15px;
  flex-direction: column;
  gap: 15px;
`;
export const Text = styled.div``;
export const Title = styled.div`
  margin-bottom: 15px;
  /* font-weight: bold; */
`;
